"use client";

import CountryContactPage from "@/components/Contact/CountryContactPage";

export default function Vietnam() {
  return <CountryContactPage headquarters="vn" />;
}
